module.exports = __webpack_public_path__ + "static/media/App.20b238d4.png";